import { CURRENCIES } from "../../constants/currency";
import { normalizeCompletePreferences } from "../../services/completePreferences";
import { getPlatformCurrency } from "../../services/currency";
import { normalizeSimplifiedBankroll } from "../../services/dataModel";
import {
  createPlatformAccount,
  SUPREMA_PLATFORM,
} from "../simplified/simplifiedAccounts";

const normalizeOnboardingPlatforms = (platforms = []) =>
  [...new Set(platforms.map((platform) => String(platform || "").trim()).filter(Boolean))];

export const requiresOnboardingCurrencyChoice = (platforms = []) => {
  const normalizedPlatforms = normalizeOnboardingPlatforms(platforms);
  const hasSuprema = normalizedPlatforms.some(
    (platform) =>
      platform.localeCompare(SUPREMA_PLATFORM, "pt-BR", {
        sensitivity: "base",
      }) === 0
  );

  return hasSuprema && normalizedPlatforms.some((platform) => getPlatformCurrency(platform) === CURRENCIES.USD);
};

export const resolveOnboardingDisplayCurrency = (
  platforms = [],
  selectedCurrency
) => {
  if (requiresOnboardingCurrencyChoice(platforms)) return selectedCurrency;

  const normalizedPlatforms = normalizeOnboardingPlatforms(platforms);
  const hasOnlySuprema =
    normalizedPlatforms.length > 0 &&
    normalizedPlatforms.every(
      (platform) => getPlatformCurrency(platform) === CURRENCIES.BRL
    );

  return hasOnlySuprema ? CURRENCIES.BRL : CURRENCIES.USD;
};

export const buildCompletePreferencesFromOnboarding = ({
  currentPreferences,
  buyInMin,
  buyInMax,
  platforms,
  completedAt,
}) =>
  normalizeCompletePreferences({
    ...currentPreferences,
    buyInMin,
    buyInMax,
    platforms: normalizeOnboardingPlatforms(platforms),
    onboardingCompletedAt: completedAt,
    hasSavedPreferences: true,
  });

export const applyOnboardingPlatformsToBankroll = (bankroll, platforms) => {
  const normalizedBankroll = normalizeSimplifiedBankroll(bankroll);
  const selectedPlatforms = normalizeOnboardingPlatforms(platforms);
  const existingAccounts = Array.isArray(normalizedBankroll.accounts)
    ? normalizedBankroll.accounts
    : [];

  const accountsByName = new Map(
    existingAccounts.map((account) => [account.name, account])
  );

  return normalizeSimplifiedBankroll({
    ...normalizedBankroll,
    accounts: selectedPlatforms.map(
      (platform) => accountsByName.get(platform) || createPlatformAccount(platform)
    ),
  });
};
